<script>
  import DynamicH2 from "../common/DynamicH2.svelte";

  export let titleVisible = false;
</script>

<div>
  {#if titleVisible}
    <DynamicH2 inputText={'This is the second page'} />
  {/if}
</div>
